import React from "react";
import { Modal, TextInput, FileInput, Button } from "@mantine/core";
import { useForm } from "@mantine/form";
import { apiWithInterceptor } from "../../../../api";
import { useLocalStorage } from "@mantine/hooks";
import { useDispatch } from "react-redux";
import { setUser as setUserRedux } from "../../../../redux/reducers/user";
const UpdateProfileModal = ({ opened, user, setEditProfile }) => {
  const [userInfoLocalStorage, setUserInfoLocalStorage] = useLocalStorage({
    key: "userInfo",
    defaultValue: JSON.parse(localStorage.getItem("userInfo")),
  });
  const dispatch = useDispatch();
  const form = useForm({
    initialValues: {
      username: user?.username,
      email: user?.email,
      profile_picture: null,
    },
  });

  return (
    <Modal
      title="Edit Profile"
      onClose={() => {
        setEditProfile(false);
      }}
      opened={opened}
    >
      <form
        onSubmit={form.onSubmit((values) => {
          const formData = new FormData();
          formData.append("username", values.username);
          formData.append("email", values.email);
          formData.append("profile_image", values.profile_picture);

          apiWithInterceptor
            .patch(`/user/${user.id}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              setUserInfoLocalStorage(res.data);
              dispatch(setUserRedux(res.data));
              setEditProfile(false);
            })
            .catch((err) => {
              console.log(err);
            });
        })}
      >
        <TextInput
          label="User name"
          placeholder="Enter your new name"
          {...form.getInputProps("username")}
        />
        <TextInput
          label="Email"
          placeholder="Enter your new email"
          {...form.getInputProps("email")}
        />

        <FileInput
          label="Profile Picture"
          placeholder="Enter your new profile picture"
          {...form.getInputProps("profile_picture")}
        />
        <Button mt={15} type="submit">
          Update
        </Button>
      </form>
    </Modal>
  );
};

export default UpdateProfileModal;
